import { render, staticRenderFns } from "./uploadlimits.vue?vue&type=template&id=44735a8a"
import script from "./uploadlimits.vue?vue&type=script&lang=js"
export * from "./uploadlimits.vue?vue&type=script&lang=js"
import style0 from "./uploadlimits.vue?vue&type=style&index=0&id=44735a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports